class CartDrawerDiscount extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleKey = this.handleKey.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  connectedCallback() {
    this.input = this.querySelector('.cart-drawer__discount-input');
    this.button = this.querySelector('.cart-drawer__discount-apply');
    this.status = this.querySelector('.cart-drawer__discount-status');
    this.button?.addEventListener('click', this.handleClick);
    this.input?.addEventListener('keydown', this.handleKey);
    this.addEventListener('click', this.handleRemove);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
    this.input?.removeEventListener('keydown', this.handleKey);
    this.removeEventListener('click', this.handleRemove);
  }

  async handleRemove(event) {
    const btn = event.target.closest('.cart-drawer__discount-tag-remove');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    const codeToRemove = btn.dataset.code;
    if (!codeToRemove) return;
    btn.disabled = true;
    try {
      // Get currently applied codes so we can re-apply the rest after clearing
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      const remaining = (cart.cart_level_discount_applications || [])
        .map((d) => d.title)
        .filter((title) => title && title.toLowerCase() !== codeToRemove.toLowerCase());

      // Clear all discount codes — POST { discount: '' } to /cart/update.js
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: '' }),
      });

      // Re-apply any other codes (rare; usually only one)
      for (const code of remaining) {
        await fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart.js`, {
          headers: { Accept: 'application/json' },
        });
      }

      document.dispatchEvent(new CustomEvent('rebuy:cart.change', { bubbles: true }));
    } catch (err) {
      console.error('Remove discount failed', err);
      btn.disabled = false;
      this.setStatus("Couldn't remove code. Try again.");
    }
  }

  handleKey(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.apply();
    }
  }

  handleClick(event) {
    event.preventDefault();
    this.apply();
  }

  async apply() {
    const code = (this.input?.value || '').trim();
    if (!code) return;
    this.setStatus('');
    this.button.disabled = true;
    try {
      const url = `/discount/${encodeURIComponent(code)}?redirect=/cart.js`;
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error(`Discount fetch ${res.status}`);
      const cart = await res.json();
      const applied = (cart.cart_level_discount_applications || []).some(
        (d) => d.code && d.code.toLowerCase() === code.toLowerCase(),
      ) || (cart.discount_codes || []).some(
        (d) => d.code && d.code.toLowerCase() === code.toLowerCase() && d.applicable,
      );
      if (applied) {
        this.setStatus('');
        this.input.value = '';
        document.dispatchEvent(new CustomEvent('rebuy:cart.change', { bubbles: true }));
      } else {
        this.setStatus("That code isn't valid.");
      }
    } catch (err) {
      console.error('Apply discount failed', err);
      this.setStatus("Couldn't apply code. Try again.");
    } finally {
      this.button.disabled = false;
    }
  }

  setStatus(message) {
    if (!this.status) return;
    this.status.textContent = message;
    this.status.hidden = !message;
  }
}

customElements.define('cart-drawer-discount', CartDrawerDiscount);
